import { render, staticRenderFns } from "./MineAppointment.vue?vue&type=template&id=15d86fa2"
import script from "./MineAppointment.vue?vue&type=script&lang=js"
export * from "./MineAppointment.vue?vue&type=script&lang=js"
import style0 from "./MineAppointment.vue?vue&type=style&index=0&id=15d86fa2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports